import { createPortal } from 'react-dom';
import { useToast } from '../../../hooks/useToast';
import styles from './Toast.module.css';

const typeClass: Record<string, string> = {
  success: styles['toast-success'],
  error: styles['toast-error'],
  warning: styles['toast-warning'],
  info: styles['toast-info'],
};

const typeIcon: Record<string, string> = {
  success: '✅',
  error: '❌',
  warning: '⚠️',
  info: 'ℹ️',
  notify: '🔔',
};

export default function ToastContainer() {
  const { toasts, hideToast } = useToast();

  if (toasts.length === 0) return null;

  return createPortal(
    <div className={styles['toast-container']}>
      {toasts.map((t) => (
        <div key={t.id} className={`${styles.toast} ${typeClass[t.type] ?? ''}`}>
          <span>{typeIcon[t.type] ?? '🔔'}</span>
          <span style={{ flex: 1 }}>{t.message}</span>
          <button className={styles['toast-close']} onClick={() => hideToast(t.id)}>
            &times;
          </button>
        </div>
      ))}
    </div>,
    document.body,
  );
}
